import { Spacer } from '@components/Spacer'
import * as Icons from '@purposity/icons'
import { analytics } from '@services/Analytics'
import * as Colors from '@themes/Colors'
import { LinearGradient } from 'expo-linear-gradient'
import * as React from 'react'
import { Text, View } from 'react-native'
import { Link } from 'solito/link'
import { DollarTag } from '../DollarTag'
import { LocationTag } from '../LocationTag'
import { badgeStyles, CardBadge } from './CardBadge'
import { cardStyles, itemStyles, NeedCardViewPropsBase, styles } from './shared'

interface Props extends NeedCardViewPropsBase {
  userMetThisNeed?: boolean
  hasThankYou?: boolean
  urgent?: boolean
}

export function MetNeedCardView(props: Props) {
  const { style: viewPropsStyle, ...viewProps } = props.containerProps ?? {}

  const handleClick = () => {
    analytics.track('Need Click', {
      needId: props.id,
      needTitle: props.title,
      isUrgent: props.urgent ?? false,
      liveNeed: false,
    })
  }

  return (
    <Link
      href={{
        pathname: '/need/[needId]',
        query: { needId: props.id, userMetThisNeed: props.userMetThisNeed },
      }}
      as={`/need/${props.id}`}
      viewProps={{
        ...viewProps,
        style: [styles.containerBase, viewPropsStyle],
        onClick: handleClick,
      }}
    >
      <LinearGradient
        colors={[
          props.hasThankYou ? Colors.purple : Colors.primary,
          Colors.primary,
        ]}
        start={{ x: 0.2, y: 0 }}
        end={{ x: 0.8, y: 1 }}
        style={styles.containerMet}
        role="article"
      >
        <View
          style={[
            styles.containerMetInternal,
            props.hasThankYou
              ? styles.containerMetInternal_withThankYou
              : styles.containerMetInternal_normal,
          ]}
        >
          <View style={itemStyles.badgesContainer} role="complementary">
            <CardBadge
              alt="This need has been met"
              color={Colors.primary}
              icon={Icons.findIconDefinition({
                prefix: 'fas',
                iconName: 'check-circle',
              })}
              wrapperStyle={
                props.hasThankYou ? badgeStyles.badge_1 : badgeStyles.badge_0
              }
            />
            {props.hasThankYou && (
              <CardBadge
                alt="A thank you note has been sent"
                color={Colors.purple}
                icon={Icons.findIconDefinition({
                  prefix: 'fas',
                  iconName: 'circle-envelope',
                })}
                wrapperStyle={badgeStyles.badge_0}
              />
            )}
          </View>
          <View style={cardStyles.header} role="banner">
            <Text style={itemStyles.orgName} numberOfLines={1}>
              {props.organizationName}
            </Text>
          </View>
          <View style={cardStyles.body}>
            <Text
              accessibilityRole="header"
              numberOfLines={1}
              style={itemStyles.needTitle}
              role="heading"
            >
              {props.title}
            </Text>
            <Spacer height={8} />
            <Text style={itemStyles.needDescription}>
              {props.shortDescription}
            </Text>
          </View>
          <View style={cardStyles.footer} role="contentinfo">
            <DollarTag value={props.priceIncludingTip} />
            <LocationTag city={props.city} state={props.state} />
          </View>
        </View>
      </LinearGradient>
    </Link>
  )
}
